import request from '@/utils/request'
// import qs from 'qs'

// 商品列表
export const pageList = (getData) => {
  return request({
    url: '/productPice-pice/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 商品单个详情
export const getId = (getData) => {
  return request({
    url: '/productPice-pice/getId',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 删除
export const deleteList = (getData) => {
  return request({
    url: '/productPice-pice/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改
export const updateList = (postData) => {
  return request({
    url: '/productPice-pice/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增
export const addList = (postData) => {
  return request({
    url: '/productPice-pice/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}


// 产品列表
export const productList = (getData) => {
  return request({
    url: '/web/product/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}

// 产品新增
export const productAdd = (postData) => {
  return request({
    url: '/web/product/saveList',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 产品修改
export const productUpdate = (postData) => {
  return request({
    url: '/web/product/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 产品删除
export const productDelete = (getData) => {
  return request({
    url: '/web/product/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 产品详情
export const productDetail = (getData) => {
  return request({
    url: '/web/product/getId',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}

// 产品名称
export const productMenus = (getData) => {
  return request({
    url: '/back/official-website-menu/menus',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 产品名称修改
export const productMenusUpdate = (postData) => {
  return request({
    url: '/back/official-website-menu/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 产品名称新增
export const menuAdd = (postData) => {
  return request({
    url: '/back/official-website-menu/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 产品名称删除
export const menuDelete = (getData) => {
  return request({
    url: '/back/official-website-menu/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}